import { VerticalFlexbox } from "@src/components/layout/Flexbox";
import { MarkdownRenderer } from "@src/components/markdown/MarkdownRenderer";
import { useCurrentPatient } from "@src/stores/app";
import { useListHealthConcerns } from "@elation/api-client/src/stitch-web";
import { BriefingAccordion } from "./BriefingAccordion";
import { CodeChip } from "./CodeChip";
import { Opportunity } from "./Opportunity";
import styles from "./HealthConcerns.module.less";

interface HealthConcernsProps {
  newOpportunityIds: Set<number>;
}

export const HealthConcerns = ({ newOpportunityIds }: HealthConcernsProps) => {
  const currentPatient = useCurrentPatient();

  const { data: healthConcernsData } = useListHealthConcerns(
    currentPatient?.id ?? -1,
    {
      query: {
        enabled: !!currentPatient?.id,
      },
    },
  );

  const healthConcerns = healthConcernsData?.data ?? [];

  return (
    <VerticalFlexbox as="ul" className={styles.root}>
      {healthConcerns.map((hc) => {
        const numberOfOpportunities = hc.opportunities?.length ?? 0;
        const codes = hc.codes ?? [];
        return (
          <li key={hc.id} data-id={hc.id}>
            <BriefingAccordion title={hc.name} subtitle={hc.diagnosticStatus}>
              <VerticalFlexbox className={styles.content}>
                <MarkdownRenderer markdown={hc.description} />
                {codes.length > 0 && (
                  <div className={styles.codeChipRow}>
                    {codes.map((c, i) => (
                      <CodeChip
                        key={`${c.codeType}-${c.code}-${i}`}
                        codeType={c.codeType}
                        code={c.code}
                        description={c.description}
                        role={c.role}
                      />
                    ))}
                  </div>
                )}
                {numberOfOpportunities > 0 && (
                  <VerticalFlexbox as="ul" className={styles.opportunities}>
                    {hc.opportunities?.map((opportunity) => (
                      <li key={opportunity.id}>
                        <Opportunity
                          opportunity={opportunity}
                          isNew={newOpportunityIds.has(opportunity.id)}
                        />
                      </li>
                    ))}
                  </VerticalFlexbox>
                )}
              </VerticalFlexbox>
            </BriefingAccordion>
          </li>
        );
      })}
    </VerticalFlexbox>
  );
};
